// AOS
import AOS from 'aos';
AOS.init({
    offset: 200,            // Scrolling Offset
    duration: 450,          // Animation Length 
    easing: "ease-in-out",  // Type of Easing
    once: true,             // No Repeat if Rescroll
});